import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Some sharing",
  "description": "",
  "published": "2007-03-14T00:00:00.000Z",
  "redirect_from": ["/blog/some-sharing/swizec/261"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Felt like sharing some sneak peeks from the march comic I'm working on, hope you like them.`}</p>
    <p><img parentName="p" {...{
        "src": "/includes/editor_upload/Image/sneeks/peak1.png",
        "alt": "Cthulhu gorges on cake",
        "title": "Cthulhu gorges on cake"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "/includes/editor_upload/Image/sneeks/peak2.png",
        "alt": "Cthulhu runs",
        "title": "Cthulhu runs"
      }}></img></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      